import { isNil, mapValues, omitBy, pick } from "lodash";
import { SessionReplayEvent } from "banco/constants/generated/constants";

export interface SessionReplayRecorder {
  setUserID: (ref: string) => void
  setMetadata: (key: string, value: string) => void
  sendEvent: (name: string, payload: Record<string, string>) => void
}

interface SessionReplayEventOptions {
  // Ref of the event's subject, e.g. the loan application or loan account. Omitted for events
  // without a subject, e.g. two_factor_failed and error_occurred.
  ref?: string
  properties?: Record<string, string | number | boolean | null | undefined>
}

const METADATA_KEYS = [
  "broker_name",
  "partner",
  "pre_approved",
  "same_brand_concurrent",
];

const stringValues = (attrs: Record<string, unknown>) => mapValues(omitBy(attrs, isNil), String);

export class SessionReplaySupport {
  static setSessionMetadata(attrs: Record<string, unknown> = {}) {
    const recorder = window.OpenReplay;
    if (!recorder) { return; }

    const ref = window.customer_ref ?? attrs.customer_ref;
    if (typeof ref === "string") { recorder.setUserID(ref); }

    Object.entries(stringValues(pick(attrs, METADATA_KEYS)))
      .forEach(([key, value]) => recorder.setMetadata(key, value));
  }

  static reportSessionEvent(
    eventName: SessionReplayEvent,
    { ref, properties = {} }: SessionReplayEventOptions = {}
  ) {
    window.OpenReplay?.sendEvent(eventName, stringValues({ ...properties, ref }));
  }

  static sendError(message: string) {
    this.reportSessionEvent(SessionReplayEvent.ERROR_OCCURRED, { properties: { message } });
  }
}

window.SessionReplaySupport = SessionReplaySupport;
